import AnalyticsActionTypes from '../actionTypes/AnalyticsActionTypes';

const triggerFormError = (errorDetails) => ({
    type: AnalyticsActionTypes.FORM_ERROR,
    errorDetails,
});

const triggerNavigationClick = (payload) => ({
    type: AnalyticsActionTypes.NAVIGATION_CLICK,
    navClick: payload,
});

const triggerAppBannerOpen = () => ({
    type: AnalyticsActionTypes.APP_BANNER_OPEN,
});

const triggerAppBannerClose = () => ({
    type: AnalyticsActionTypes.APP_BANNER_CLOSE,
});

const selectStoreData = () => ({
    type: AnalyticsActionTypes.ANALYTICS_SELECT_STORE,
});

const storeSearchData = (payload) => ({
    type: AnalyticsActionTypes.ANALYTICS_STORE_SEARCH,
    payload,
});

// Gallery store change event
const bopisChangeZip = (payload) => ({
    type: AnalyticsActionTypes.BOPIS_CHANGE_ZIP,
    payload,
});

const videoLoadedData = (payload) => ({
    type: AnalyticsActionTypes.ANALYTICS_VIDEO_LOADED,
    payload,
});
/* istanbul ignore next */
const openModelEvent = (payload) => ({
    type: AnalyticsActionTypes.ANALYTICS_OPEN_MODAL,
    name: payload.name,
});

const updateAnalyticsClickAction = (payload) => ({
    type: AnalyticsActionTypes.UPDATE_ANALYTICS_CLICK_EVENT,
    payload,
});

const removeAnalyticsClickAction = (payload) => ({
    type: AnalyticsActionTypes.REMOVE_ANALYTICS_CLICK_EVENT,
    payload,
});

const compareProductsClick = (payload) => ({
    type: AnalyticsActionTypes.COMPARE_PRODUCTS_CLICK,
    payload,
});

const pdpToolClickAnalytics = (payload) => ({
    type: AnalyticsActionTypes.PDP_TOOL_CLICK_ANALYTICS,
    payload,
});

const productOOSAnalytics = () => ({
    type: AnalyticsActionTypes.PDP_PRODUCT_OOS_ANALYTICS,
});

const openModalAnalytics = (payload) => ({
    type: AnalyticsActionTypes.PDP_OPEN_MODAL_ANALYTICS,
    payload,
});

const productRecommendationAnalytics = (payload) => ({
    type: AnalyticsActionTypes.PRODUCT_RECOMMENDATIONS_ANALYTICS,
    payload,
});

const saveBreadCrumbData = (breadcrumbData) => ({
    type: AnalyticsActionTypes.BREADCRUMB_ANALYTICS,
    breadcrumbData,
});

const promotedFilterChange = (payload) => ({
    type: AnalyticsActionTypes.PROMOTED_FILTERS_APPLIED,
    payload,
});

const triggerFilterByPillsAnalytics = (payload) => ({
    type: AnalyticsActionTypes.FILTERS_BY_PILLS_ANALYTICS,
    payload,
});

const fitFinderModalAndPersonaAnalytics = () => ({
    type: AnalyticsActionTypes.FITFINDER_MODAL_AND_PERSONA,
});

const triggerPageReady = () => ({
    type: AnalyticsActionTypes.TRIGGER_PAGE_READY,
});

const triggerActiveCartReminder = () => ({
    type: AnalyticsActionTypes.TRIGGER_ACTIVE_CART_REMINDER,
});

const triggerBopisModal = () => ({
    type: AnalyticsActionTypes.TRIGGER_BOPIS_MODAL,
});

const triggerBopisPickupStoreChange = () => ({
    type: AnalyticsActionTypes.TRIGGER_BOPIS_PICKUP_STORE_CHANGE,
});

const triggerBopisDefaultStoreChange = () => ({
    type: AnalyticsActionTypes.TRIGGER_BOPIS_DEFAULT_STORE_CHANGE,
});

const klarnaOnSiteMessagingAnalytics = () => ({
    type: AnalyticsActionTypes.KLARNA_ON_SITE_MESSAGING_ANALYTICS,
});

const continueWithKlarnaAnalytics = () => ({
    type: AnalyticsActionTypes.CONTINUE_WITH_KLARNA_ANALYTICS,
});

const triggerRevieveAddToCartAnalytics = (payload) => ({
    type: AnalyticsActionTypes.TRIGGER_REVIEVE_ADDTOCART_ANALYTICS,
    payload,
});

const triggerSkinCareModal = () => ({
    type: AnalyticsActionTypes.TRIGGER_SKINCARE_MODAL,
});

const triggerVTOModal = () => ({
    type: AnalyticsActionTypes.TRIGGER_VTO_MODAL,
});

export default {
    triggerFormError,
    triggerNavigationClick,
    triggerAppBannerOpen,
    triggerAppBannerClose,
    selectStoreData,
    videoLoadedData,
    openModelEvent,
    updateAnalyticsClickAction,
    removeAnalyticsClickAction,
    storeSearchData,
    bopisChangeZip,
    compareProductsClick,
    pdpToolClickAnalytics,
    openModalAnalytics,
    productOOSAnalytics,
    productRecommendationAnalytics,
    saveBreadCrumbData,
    promotedFilterChange,
    triggerFilterByPillsAnalytics,
    fitFinderModalAndPersonaAnalytics,
    triggerPageReady,
    triggerActiveCartReminder,
    triggerBopisModal,
    triggerBopisPickupStoreChange,
    triggerBopisDefaultStoreChange,
    klarnaOnSiteMessagingAnalytics,
    continueWithKlarnaAnalytics,
    triggerRevieveAddToCartAnalytics,
    triggerSkinCareModal,
    triggerVTOModal,
};
